import React, { createContext, useCallback, useState } from 'react';
import ScreenPickerModal from '../components/ScreenPickerModal';

// PopoutContext owns the single screen-picker modal that all usePopout
// callers share. Alternative would be each hook instance rendering its
// own modal — rejected because the terminal mounts usePopout in both
// panel headers (commit 5) and workspace tab menus (commit 6), and
// duplicate modals would race or stack. One global provider, one modal,
// one source of truth.
//
// The provider exposes a single operation — requestScreenPick — that
// the hook calls when it needs to ask the user which screen to open
// on. The provider tracks modal visibility and the user's picked or
// cancelled outcome internally and runs the hook-supplied callbacks.

export const PopoutContext = createContext(null);

export function PopoutProvider({ children }) {
  // null when no pick in flight; otherwise { screens, onSelect, onCancel }
  const [pickRequest, setPickRequest] = useState(null);

  const requestScreenPick = useCallback((request) => {
    setPickRequest(request);
  }, []);

  const handleSelect = useCallback((screen, opts) => {
    const current = pickRequest;
    setPickRequest(null);
    current?.onSelect?.(screen, opts);
  }, [pickRequest]);

  const handleCancel = useCallback(() => {
    const current = pickRequest;
    setPickRequest(null);
    current?.onCancel?.();
  }, [pickRequest]);

  return (
    <PopoutContext.Provider value={{ requestScreenPick }}>
      {children}
      {pickRequest && (
        <ScreenPickerModal
          screens={pickRequest.screens}
          onSelect={handleSelect}
          onCancel={handleCancel}
        />
      )}
    </PopoutContext.Provider>
  );
}
